/**
 * CSV utility functions for exporting transaction data
 */

/**
 * Escapes fields for CSV format
 */
export const escapeCSVField = (field) => {
  if (field === null || field === undefined) return '';
  if (field === true) return 'yes';
  if (field === false) return 'no';
  const stringField = String(field);
  if (stringField.includes(',') || stringField.includes('"') || stringField.includes('\n')) {
    return `"${stringField.replace(/"/g, '""')}"`;
  }
  return stringField;
};

/**
 * Gets the maximum number of tags across all rows
 */
export const getMaxTagCount = (data) => {
  return Math.max(...data.map(row => (row.tags || []).length), 0);
};

/**
 * Generates CSV content from transaction data
 */
export const generateCSV = (data) => {
  const maxTags = getMaxTagCount(data);
  const tagColumns = Array.from({ length: maxTags }, (_, i) => `tag${i + 1}`);
  
  // Generate header row
  const headers = ['date', 'amount', 'description', 'description2', ...tagColumns, 'tax', 'comments'];
  const headerRow = headers.join(',');

  // Generate data rows
  const rows = data.map(row => {
    const tags = row.tags || [];
    const tagValues = Array.from({ length: maxTags }, (_, i) => escapeCSVField(tags[i] || ''));
    
    return [
      escapeCSVField(row.date),
      escapeCSVField(row.amount),
      escapeCSVField(row.description),
      escapeCSVField(row.description2),
      ...tagValues,
      escapeCSVField(row.tax),
      escapeCSVField(row.comments)
    ].join(',');
  });

  return [headerRow, ...rows].join('\n');
};

/**
 * Downloads CSV file
 */
export const downloadCSV = (csvContent, filename) => {
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  if (link.download !== undefined) {
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
};